// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var MsisdnFilter$ReactHooksTemplate = require("./msisdnFilter.res.js");
var MsisdnSelected$ReactHooksTemplate = require("./msisdnSelected.res.js");

function MsisdnFilterForm(props) {
  var onChange = props.onChange;
  var filter = props.filter;
  var handleOnChange = function ($$event) {
    Curry._1(onChange, {
          TAG: "Msisdn",
          _0: MsisdnFilter$ReactHooksTemplate.setSelected(Caml_option.some(MsisdnSelected$ReactHooksTemplate.make(Utils$ReactHooksTemplate.formTargetValue($$event))), filter)
        });
  };
  return JsxRuntime.jsx("label", {
              children: JsxRuntime.jsx("input", {
                    className: "border border-gray-300 hover:border-gray-400 focus:border-palatinateblue outline-none p-3 mt-4 text-sm bg-transparent w-4/5 rounded",
                    type: "text",
                    value: MsisdnFilter$ReactHooksTemplate.toString(filter),
                    onChange: handleOnChange
                  })
            });
}

var make = MsisdnFilterForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
